import api from './api'

export function fetchRelationships(userId) {
  return api.get(`/users/${userId}/relationships`)
}

export function sendFriendRequest(userId, identifier) {
  return api.post(`/users/${userId}/friend-requests`, { identifier })
}

export function respondFriendRequest(userId, requestId, action) {
  return api.post(`/users/${userId}/friend-requests/${requestId}/respond`, { action })
}

export function removeFriend(userId, friendId) {
  return api.delete(`/users/${userId}/friends/${friendId}`)
}

export function updateBlock(userId, blockedUserId, { blockChat = false, blockFriendRequests = false } = {}) {
  return api.post(`/users/${userId}/blocks`, {
    blockedUserId,
    blockChat,
    blockFriendRequests
  })
}

export function removeBlock(userId, blockedUserId) {
  return api.delete(`/users/${userId}/blocks/${blockedUserId}`)
}
